import { CardActionArea, SxProps, Typography, useTheme } from '@mui/material'
import { FlexBox } from 'components/atoms'
import { useBetContext } from 'contexts/BetContext'
import { FilterIcon } from 'icons'

export const Filter = ({
    title,
    isEnabled = false,
    onClick,
    sx = {}
}: {
    isEnabled?: boolean
    title: string
    onClick?: () => void
    sx?: SxProps
}) => {
    const theme = useTheme()
    const { mainColor } = useBetContext()

    return (
        <CardActionArea
            onClick={() => onClick && onClick()}
            sx={{ width: 'fit-content', ...sx }}
        >
            <FlexBox>
                <FilterIcon fill={isEnabled ? mainColor : '#92929D'} />
                <Typography
                    sx={{
                        color: isEnabled
                            ? mainColor
                            : theme.palette.text.secondary
                    }}
                    variant="text-14-regular"
                >
                    {title}
                </Typography>
            </FlexBox>
        </CardActionArea>
    )
}
